// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

import apiHandle from '../../../../../configs/apiConfig'


export const manageExpensesCreate = createAsyncThunk('manageExpenses/list-expenses/create', async (params) => {
  const response = await apiHandle('POST', 'list-expenses/create', params)
  return response
})

export const manageExpensesUpdate = createAsyncThunk('manageExpenses/list-expenses/update', async (params) => {
  const response = await apiHandle('PUT', 'list-expenses/update', params)
  return response
})

export const manageExpensesRefund = createAsyncThunk('manageExpenses/application/refund', async (params) => {
  const response = await apiHandle('POST', 'application/refund', params)
  return response
})

export const manageExpensesDelete = createAsyncThunk('manageExpenses/list-expenses/delete', async (params) => {
  const response = await apiHandle('DELETE', 'list-expenses/delete', params)
  return response
})


export const manageExpensesPDFCreate = createAsyncThunk('manageExpenses/application/pdf/create', async (params) => {
  const response = await apiHandle('POST', 'application/pdf', params)
  return response
})

export const manageExpensesReaderCard = createAsyncThunk('manageExpenses/manageExpensesReaderCard', async () => {
  const response = await apiHandle('GET', 'mockreadercard')
  return response
})

export const manageExpensesGetList = createAsyncThunk('manageExpenses/list-expenses/list', async (params) => {
  const response = await apiHandle('GET', 'list-expenses/list', params)
  return response
})

export const getDataTable = createAsyncThunk('manageExpenses/getDataTable', async (params) => {
  const response = await apiHandle('GET', 'list-expenses/gettable', params)
  return response
})

export const manageExpensesDataDetail = createAsyncThunk('manageExpenses/list-expenses/get', async (params) => {
  const response = await apiHandle('GET', 'list-expenses/get', params)
  return response
})

export const manageExpensesGetCourse = createAsyncThunk('manageExpenses/manageExpensesGetCourse', async (params) => {
  const response = await apiHandle('GET', 'application/getformanageExpenses', params)
  return response
})

export const getAllData = createAsyncThunk('manageExpenses/getAllData', async () => {
  const response = await axios.get('/api/users/list/all-data')
  return response.data
})

export const getData = createAsyncThunk('manageExpenses/getData', async params => {
  const response = await axios.get('/api/users/list/data', params)
  return {
    params,
    data: response.data.users,
    totalPages: response.data.total
  }
})

export const getUser = createAsyncThunk('manageExpenses/getUser', async id => {
  const response = await axios.get('/api/users/user', { id })
  return response.data.user
})

export const addUser = createAsyncThunk('manageExpenses/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('manageExpenses/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})

const defaultExpensesDetail = {
  // branch_id: null,
  // code: null,
  // createdAt: null,
  // detail: null,
  // end: null,
  // is_activate: null,
  // is_delete: null,
  // is_unlimit: null,
  // limit: null,
  // name: null,
  // promotion_id: null,
  // start: null,
  // type: null,
  // type_discount: null,
  // updatedAt: null,
  // usage: null,
  // value: null,
  branch_id: null,
  category: null,
  createdAt: null,
  detail: null,
  is_delete: null,
  list_expenses_id: null,
  name: null,
  status: null,
  type: null,
  updatedAt: null,
  createStatus: false
}


export const manageExpensesSlice = createSlice({
  name: 'manageExpenses',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    searchCriteria: {
      branch: { label: 'ทั้งหมด', value: 'ทั้งหมด' },
      category: { label: 'ทั้งหมด', value: 'ทั้งหมด' },
      status: { label: 'ทั้งหมด', value: 'ทั้งหมด' },
      text: ''
    },
    manageExpensesData: {
      data: [],
      filter: {
        branch: [],
        category: [],
        status: []
      },
      meta: {},
      isLoading: false
    },
    manageExpensesDetail: {
      isEdit: false,
      dropdown: {
        category: [],
        status: []
      },
      expensesData: defaultExpensesDetail
    },
    alert: {
      active: false,
      message: '',
      err: false
    },
    refundAndDelete: {
      application_id: null,
      note: null,
      value: null,
      err: false
    }
  },
  reducers: {
    searchCriteria: (state, action) => {
      if (action.type === 'manageExpenses/searchCriteria') {
        state.searchCriteria[action.payload.target] = action.payload.value
      }
    },
    manageExpensesNew: (state, action) => {
      if (action.type === 'manageExpenses/manageExpensesNew') {
        state.manageExpensesDetail.isEdit = false
        state.manageExpensesDetail.expensesData = defaultExpensesDetail
        state.alert.active = false
        state.alert.message = ''
        state.alert.err = false
      }
    },
    manageExpensesAddHandle: (state, action) => {
      if (action.type === 'manageExpenses/manageExpensesAddHandle') {
        if (action.payload.target === 'course') {
          state.manageExpensesDetail.expensesData.course.push(defaultCoruseCost)
        }
        if (action.payload.target === 'other') {
          state.manageExpensesDetail.expensesData.other_fee.push(defaultOtherCost)
        }

      }
    },
    manageExpensesDeleteHandle: (state, action) => {
      if (action.type === 'manageExpenses/manageExpensesDeleteHandle') {
        if (action.payload.target === 'course') {
          state.manageExpensesDetail.expensesData.course.splice(action.payload.index, 1)
        }
        if (action.payload.target === 'other') {
          state.manageExpensesDetail.expensesData.other_fee.splice(action.payload.index, 1)
        }

      }

    },
    manageExpensesDropdownHandle: (state, action) => {
      if (action.type === 'manageExpenses/manageExpensesDropdownHandle') {
        console.log(action.payload.target)
        if (action.payload.target === 'course' && state.manageExpensesDetail.isEdit === false) {
          state.manageExpensesDetail.expensesData.course[action.payload.index].course_id = action.payload.value.course_id
          state.manageExpensesDetail.expensesData.course[action.payload.index].course_name = action.payload.value.name
          state.manageExpensesDetail.expensesData.course[action.payload.index].cost = action.payload.value.price
        }
        if (action.payload.target === 'examDate') {
          state.manageExpensesDetail.expensesData.course[action.payload.index].exam_date = action.payload.value
        }
        if (action.payload.target === 'other' && state.manageExpensesDetail.isEdit === false) {
          state.manageExpensesDetail.expensesData.other_fee[action.payload.index].other_fee_id = action.payload.value.other_fee_id
          state.manageExpensesDetail.expensesData.other_fee[action.payload.index].other_fee_name = action.payload.value.name
          state.manageExpensesDetail.expensesData.other_fee[action.payload.index].cost = action.payload.value.price
        }
        if (action.payload.target === 'pay_type') {
          state.manageExpensesDetail.expensesData[action.payload.mode][action.payload.index].pay_type = action.payload.value
        }
      }
    },
    manageExpensesOnChangeHandle: (state, action) => {
      if (action.type === 'manageExpenses/manageExpensesOnChangeHandle') {
        if (action.payload.target === 'paid') {
          state.manageExpensesDetail.expensesData[action.payload.mode][action.payload.index][action.payload.target] = action.payload.value
        } else {
          state.manageExpensesDetail.expensesData[action.payload.target] = action.payload.value
        }

      }
    },
    manageExpensesLoading: (state, action) => {
      if (action.type === 'manageExpenses/manageExpensesLoading') {
        state.manageExpensesData.isLoading = true
      }
    },
    manageExpensesAlert: (state, action) => {
      if (action.type === 'manageExpenses/manageExpensesAlert') {
        state.alert.active = false
        state.alert.message = ''
        state.alert.err = false
      }
    },
    manageExpensesRefundDelete: (state, action) => {
      if (action.type === 'manageExpenses/manageExpensesRefundDelete') {
        if (action.payload.target === null) {
          state.refundAndDelete.application_id = null
          state.refundAndDelete.note = null
          state.refundAndDelete.value = null
        } else {
          state.refundAndDelete[action.payload.target] = action.payload.value
        }

      }
    }

  },
  extraReducers: builder => {
    builder
      .addCase(manageExpensesCreate.fulfilled, (state, action) => {
        if (action.type === 'manageExpenses/list-expenses/create/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
            state.alert.active = true
            state.alert.message = action.payload.message
            state.alert.err = true
          } else {
            state.alert.active = true
            state.alert.message = action.payload.message
            state.alert.err = false
            // state.manageExpensesDetail.expensesData.createStatus = true
            // state.manageExpensesDetail.expensesData.pdf = action.payload.data
          }
        }
      })
      .addCase(manageExpensesUpdate.fulfilled, (state, action) => {
        if (action.type === 'manageExpenses/list-expenses/update/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
            state.alert.active = true
            state.alert.message = action.payload.message
            state.alert.err = true
          } else {
            console.log(action)
            state.alert.active = true
            state.alert.message = action.payload.message
            state.alert.err = false
            // state.manageExpensesDetail.expensesData.createStatus = true
            // state.manageExpensesDetail.expensesData.pdf = action.payload.data
          }
        }
      })
      .addCase(manageExpensesGetList.fulfilled, (state, action) => {
        if (action.type === 'manageExpenses/list-expenses/list/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            let category = []
            let status = []
            if (action.payload.data) {
              for (const i in action.payload.data) {
                if (Array.isArray(action.payload.data[i])) {
                  for (const j of action.payload.data[i]) {
                    if (i === 'category') {
                      category.push({ label: j, value: j })
                    } else {
                      status.push({ label: j, value: j })
                    }
                  }
                }
                // arr.push({ value: i, label: i })
              }
            }
            state.manageExpensesDetail.dropdown.category = category
            state.manageExpensesDetail.dropdown.status = status
          }
        }
      })
      .addCase(manageExpensesRefund.fulfilled, (state, action) => {
        if (action.type === 'manageExpenses/application/refund/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
            state.refundAndDelete.application_id = null
            state.refundAndDelete.note = null
            state.refundAndDelete.value = null
            state.alert.active = true
            state.alert.err = true
            state.alert.message = action.payload.message
          } else {
            state.refundAndDelete.application_id = null
            state.refundAndDelete.note = null
            state.refundAndDelete.value = null
            state.alert.active = true
            state.alert.message = action.payload.message
          }
        }
      })
      .addCase(manageExpensesDelete.fulfilled, (state, action) => {
        if (action.type === 'manageExpenses/list-expenses/delete/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
            state.alert.active = true
            state.alert.message = action.payload.message
            state.alert.err = true
          } else {
            console.log(action)
            state.alert.active = true
            state.alert.message = action.payload.message
            state.alert.err = false
          }
        }
      })
      .addCase(getDataTable.fulfilled, (state, action) => {
        if (action.type === 'manageExpenses/getDataTable/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.manageExpensesData = action.payload
            state.manageExpensesData.isLoading = false
          }
        }
      })
      .addCase(manageExpensesDataDetail.fulfilled, (state, action) => {
        if (action.type === 'manageExpenses/list-expenses/get/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.manageExpensesDetail.isEdit = true
            for (const i in action.payload.data) {
              let data = action.payload.data[i]
              console.log('data', data)
              state.manageExpensesDetail.expensesData[i] = data
            }
          }
        }
      })
      .addCase(manageExpensesGetCourse.fulfilled, (state, action) => {
        if (action.type === 'manageExpenses/manageExpensesGetCourse/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.manageExpensesDetail.dropdown.course = action.payload.course
            state.manageExpensesDetail.dropdown.other_fee = action.payload.other_fee
          }
        }
      })
      .addCase(manageExpensesReaderCard.fulfilled, (state, action) => {
        if (action.type === 'manageExpenses/manageExpensesReaderCard/fulfilled') {
          if (action.payload.result === 'ok') {
            state.manageExpensesDetail.expensesData.prefix = action.payload.title_th
            state.manageExpensesDetail.expensesData.name = `${action.payload.fname_th} ${action.payload.sname_th}`
            state.manageExpensesDetail.expensesData.idcard = action.payload.nat_id
            state.manageExpensesDetail.expensesData.birthday = action.payload.birthdate
            state.manageExpensesDetail.expensesData.address = action.payload.address_no
            state.manageExpensesDetail.expensesData.street = action.payload.address_road
            state.manageExpensesDetail.expensesData.province = action.payload.address_provinice
            state.manageExpensesDetail.expensesData.district = action.payload.address_amphor
            state.manageExpensesDetail.expensesData.subdistrict = action.payload.address_tumbol
            state.manageExpensesDetail.expensesData.age = null

          } else {
            //handleError
          }
        }
      })
      .addCase(manageExpensesPDFCreate.fulfilled, (state, action) => {
        console.log(action)
        if (action.type === 'manageExpenses/application/pdf/create/fulfilled') {
          if (action.payload.status === 'success') {
            window.open(action.payload.data.pdf, '_blank')
          } else {
            //handleError
          }
        }
      })
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })

  }
})

export const { searchCriteria, manageExpensesNew, manageExpensesAddHandle, manageExpensesDropdownHandle, manageExpensesDeleteHandle, manageExpensesOnChangeHandle, manageExpensesLoading, manageExpensesAlert, manageExpensesRefundDelete } = manageExpensesSlice.actions

export default manageExpensesSlice.reducer
